import { render } from "./RsvpSection.vue?vue&type=template&id=feb3f402&scoped=true"
import script from "./RsvpSection.vue?vue&type=script&lang=js"
export * from "./RsvpSection.vue?vue&type=script&lang=js"

import "./RsvpSection.vue?vue&type=style&index=0&id=feb3f402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb3f402"]])

export default __exports__